export default theme => ({
  dialogPaper: {
    overflow: 'initial',
    color: theme.palette.white.main,
    backgroundColor: theme.palette.purple.main,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    height: '100%',
    '& > *': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: '1 1 0',
      width: '100%',
      minHeight: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& > *': {
        minHeight: 'unset',
      },
    },
  },
  text: {
    padding: theme.spacing(6, 8),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 4),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
  autor: {
    paddingTop: theme.spacing(1),
  },
  image: {
    display: 'block',
    width: '100%',
  },
  desc: {
    padding: theme.spacing(4),
  },
  closeIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 56,
    width: 56,
    transform: 'translate(50%,-50%)',
    [theme.breakpoints.down('sm')]: {
      height: 40,
      width: 40,
      '& svg': {
        height: 25,
        width: 25,
      },
    },
    [theme.breakpoints.down('xs')]: {
      height: 32,
      width: 32,
      minHeight: 32,
      right: theme.spacing(4),
      '& svg': {
        height: 20,
        width: 20,
      },
    },
  },
});
